import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api from "../lib/api";
import { formatGs } from "../lib/format";
import { Coins, Clock, CheckCircle2 } from "lucide-react";

export default function MiLiquidacion() {
  const { setMobileOpen } = useOutletContext();
  const [data, setData] = useState(null);
  const load = useCallback(() => { api.get("/mi-liquidacion").then(({ data }) => setData(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const items = data?.items || [];

  return (
    <>
      <Header title="Mi liquidación" subtitle="Lo que te corresponde percibir por tus ventas COD, envío pagado o crédito (valor del producto)" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white rounded-2xl border border-amber-200 p-5 shadow-sm" data-testid="mi-liq-pendiente">
            <Clock className="h-6 w-6 text-[#F5A623]" />
            <div className="text-2xl font-extrabold text-[#0A1F44] mt-3">{formatGs(data?.pendiente || 0)}</div>
            <div className="text-sm text-[#64748B]">Pendiente de cobro</div>
          </div>
          <div className="bg-white rounded-2xl border border-emerald-200 p-5 shadow-sm" data-testid="mi-liq-liquidado">
            <CheckCircle2 className="h-6 w-6 text-emerald-600" />
            <div className="text-2xl font-extrabold text-[#0A1F44] mt-3">{formatGs(data?.liquidado || 0)}</div>
            <div className="text-sm text-[#64748B]">Ya liquidado</div>
          </div>
          <div className="bg-white rounded-2xl border border-[#E2E8F0] p-5 shadow-sm" data-testid="mi-liq-total">
            <Coins className="h-6 w-6 text-[#0A1F44]" />
            <div className="text-2xl font-extrabold text-[#0A1F44] mt-3">{formatGs(data?.total || 0)}</div>
            <div className="text-sm text-[#64748B]">Total ({data?.cantidad || 0} entregas)</div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-[#E2E8F0] shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-100 font-semibold text-[#0A1F44]">Detalle de entregas cobradas por tu cuenta</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[#64748B] text-xs uppercase">
                <tr><th className="text-left font-semibold px-4 py-3">Código</th><th className="text-left font-semibold px-4 py-3">Destinatario</th><th className="text-right font-semibold px-4 py-3">Valor producto</th><th className="text-right font-semibold px-4 py-3">Estado</th></tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {items.map((r) => (
                  <tr key={r.code} className="hover:bg-slate-50/60" data-testid={`mi-liq-row-${r.code}`}>
                    <td className="px-4 py-3 font-mono font-bold text-xs">{r.code}</td>
                    <td className="px-4 py-3">{r.destinatario}<div className="text-xs text-[#64748B]">{r.ciudad}</div></td>
                    <td className="px-4 py-3 text-right font-semibold text-[#0A1F44]">{formatGs(r.valor_producto)}</td>
                    <td className="px-4 py-3 text-right">
                      <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${r.liquidado ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>{r.liquidado ? "Liquidado" : "Pendiente"}</span>
                    </td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-[#64748B]">Todavía no tenés entregas cobradas por tu cuenta.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </>
  );
}
